import React from 'react';

export const ExternalPageIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props}
      data-testid='external-page-icon'
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className='fill-primary-foreground cursor-pointer'
    >
      <path d='M14.8125 3.28564C14.5031 3.28564 14.25 3.53877 14.25 3.84814C14.25 4.15752 14.5031 4.41064 14.8125 4.41064H19.0805L10.4777 13.0134C10.2598 13.2313 10.2598 13.5899 10.4777 13.8079C10.6957 14.0259 11.0543 14.0259 11.2723 13.8079L19.875 5.20518V9.47314C19.875 9.78252 20.1281 10.0356 20.4375 10.0356C20.7469 10.0356 21 9.78252 21 9.47314V3.84814C21 3.53877 20.7469 3.28564 20.4375 3.28564H14.8125ZM5.25 4.41064C4.00898 4.41064 3 5.41963 3 6.66064V19.0356C3 20.2767 4.00898 21.2856 5.25 21.2856H17.625C18.866 21.2856 19.875 20.2767 19.875 19.0356V13.9731C19.875 13.6638 19.6219 13.4106 19.3125 13.4106C19.0031 13.4106 18.75 13.6638 18.75 13.9731V19.0356C18.75 19.6579 18.2473 20.1606 17.625 20.1606H5.25C4.62773 20.1606 4.125 19.6579 4.125 19.0356V6.66064C4.125 6.03838 4.62773 5.53564 5.25 5.53564H10.3125C10.6219 5.53564 10.875 5.28252 10.875 4.97314C10.875 4.66377 10.6219 4.41064 10.3125 4.41064H5.25Z' />
    </svg>
  )
}
